import React from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'

import { IconButton, Card, Flex } from 'adl'
import { Link } from 'react-router-dom'
import { Row, Col, Visible } from 'react-grid-system'

import numeral from 'numeral'

import ListItem from 'components/ListItem'
import StandardLayout from 'components/layouts/Standard'
import Spending from 'components/Spending'

const AccountListItem = ({ id, nickname, balance, mask }) => {
  return (
    <ListItem>
      <Flex justify="space-between">
        <div>
          <ListItem.LargeLink to={`/account-details/${id}`} as={Link}>
            {nickname}
          </ListItem.LargeLink>
          <ListItem.SubText>{mask ? '••••' + mask : null}</ListItem.SubText>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center'
          }}
        >
          <div style={{ textAlign: 'right', marginRight: 16 }}>
            <ListItem.LargeText>
              {numeral(balance).format('$0,0.00')}
            </ListItem.LargeText>
          </div>

          <div>
            <IconButton iconColor="interactive">
              <i className="icon-more" />
            </IconButton>
          </div>
        </div>
      </Flex>
    </ListItem>
  )
}

const WelcomeTitle = styled.div`
  font-size: 2rem;
  margin-bottom: 2rem;

  @media only screen and (max-width: 450px) {
    font-size: 1.44rem;
  }
`

export default () => {
  const accounts = useSelector(state => state.accounts.accounts)
  const username = useSelector(state => state.user.firstName)
  const depositAccounts = accounts.filter(a => a.type === 'deposit')
  const cards = accounts.filter(a => a.type === 'card')
  const loans = accounts.filter(a => a.type === 'loan')

  return (
    <StandardLayout>
      <WelcomeTitle>Welcome back, {username}</WelcomeTitle>

      <Row>
        <Col style={{ maxWidth: 768 }}>
          <div>
            {depositAccounts && depositAccounts.length > 0 && (
              <Card elevation={2}>
                <Card.Header>
                  <Flex justify="space-between" style={{ paddingRight: 40 }}>
                    <div>Deposit Accounts</div>
                    <div>Available Balance</div>
                  </Flex>
                </Card.Header>

                {depositAccounts.map((a, index) => (
                  <AccountListItem key={index} {...a} />
                ))}
              </Card>
            )}

            {cards && cards.length > 0 && (
              <Card elevation={2}>
                <Card.Header>
                  <Flex justify="space-between" style={{ paddingRight: 40 }}>
                    <div>Credit Cards</div>
                    <div>Current Balance</div>
                  </Flex>
                </Card.Header>
                {cards.map((a, index) => (
                  <AccountListItem key={index} {...a} />
                ))}
              </Card>
            )}

            {loans && loans.length > 0 && (
              <Card elevation={2}>
                <Card.Header>
                  <Flex justify="space-between" style={{ paddingRight: 40 }}>
                    <div>Loans & Mortgages</div>
                    <div>Current Balance</div>
                  </Flex>
                </Card.Header>

                {loans.map((a, index) => (
                  <AccountListItem key={index} {...a} />
                ))}
              </Card>
            )}
          </div>
        </Col>
        <Visible md lg xl>
          <Col md={'content'} style={{ width: 256 }}>
            <Spending />
          </Col>
        </Visible>
      </Row>
    </StandardLayout>
  )
}
